export enum LoadingStatus {
  Idle = 'idle',
  Pending = 'pending',
  Succeeded = 'succeeded',
  Failed = 'failed',
}

export enum SortingBy {
  contractorName = 'ContractorName',
  amount = 'Amount',
  amountLeft = 'AmountLeft',
  daysLeft = 'DaysLeft',
  invoiceStatus = 'InvoiceStatus',
  dueDate = 'DueDate',
}

export enum SortingOrder {
  Asc = 1,
  Desc,
}

export enum FileImportErrorKey {
  invalidExtension = 'fileInvalidType',
  fileRequired = 'fileRequired',
  fileIsEmpty = 'fileIsEmpty',
  fileTooLarge = 'fileTooLarge',
  tooFewColumns = 'tooFewColumns',
  uploadFailed = 'uploadFailed',
  missingData = 'missingData',
  default = 'failed',
}

export enum FileImportErrorCode {
  invalidExtension = 'ERR_FILE_001',
  fileRequired = 'ERR_FILE_002',
  fileIsEmpty = 'ERR_FILE_003',
  fileTooLarge = 'ERR_FILE_004',
  uploadFailed = 'ERR_FILE_UNPROCESSABLE_ENTITY',
  tooFewColumns = 'ERR_INV_IMPORT_001',
  missingMapping = 'ERR_INV_IMPORT_002',
  missingHeader = 'ERR_INV_IMPORT_003',
  emptyCell = 'ERR_INV_IMPORT_004',
  incorrectMappings = 'ERR_INV_IMPORT_005',
  duplicatedHeaders = 'ERR_INV_IMPORT_006',
  noData = 'ERR_INV_IMPORT_007',
  missingData = 'ERR_INV_IMPORT_008',
}

export enum TaxNumberErrorKey {
  doesNotExist = 'doesNotExist',
  alreadyAdded = 'alreadyAdded',
}

export enum TaxNumberErrorCode {
  alreadyAdded = 'ERR_001',
  doesNotExist = 'ERR_002',
}

export enum UserAttributes {
  avatarUrl = 'custom:avatarUrl',
  role = 'custom:role',
  name = 'name',
}

export enum InvoiceNumberErrorCode {
  alreadyAdded = 'ERR_003',
  length = 'ERR_006',
}

export enum InvoiceNumberErrorKey {
  alreadyAdded = 'alreadyAdded',
  length = 'length',
}

export enum UserRole {
  User = 'user',
  Accountant = 'accountant',
  Lawyer = 'lawyer',
}

export enum FileType {
  PowerOfAttorney = 1,
  Additional,
  Invoice,
}

export enum MessageSender {
  Lawyer = 1,
  User,
}

export enum VerifyStatus {
  NotVerified = 1,
  Verified,
  Rejected,
}

export enum FeeType {
  Lawsuit = 1,
  PowerOfAttorney,
}

export enum CognitoError {
  UserNotFound = 'UserNotFoundException',
}

export enum LawsuitSorting {
  CreatedAt = 1,
  UpdatedAt,
  Name,
  DebtorName,
}

export enum LawsuitUpdateStatus {
  Redundant = 1,
  Requested,
  Updated,
}

export enum NotificationStatus {
  Success = 1,
  PartialSuccess,
  Fail,
}

export enum InvoiceHistoryEvent {
  Created = 1,
  NotificationSent,
  PreTrialPaymentRequestSent,
  LawsuitFiled,
  LawsuitFinished,
  LawsuitRejected,
  LawsuitCancelled,
}

export enum InvoiceStatus {
  ActionRequired = 1,
  ActionTaken,
  PreTrialPaymentRequestSent,
  LawsuitFiled,
}

export enum UserType {
  Admin = 'admin',
  SuperAdmin = 'superadmin',
  User = 'user',
}

export enum RecommendedAction {
  SendReminder = 1,
  SendPreTrialPaymentRequest,
  FileLawsuit,
}

export enum PaymentStatus {
  Success = 'success',
  Processing = 'processing',
  Error = 'error',
}
